export const SUPPORT_URL = "https://www.tines.com/contact/#support";

export function openSupportUrl() {
  window.open(SUPPORT_URL, "_blank", "noopener,noreferrer");
}
